import * as actions from './auth.actions';
import { User } from '../administration/user/user.models';


export const getExpiration = (token: string | undefined): any => {
  if (!token) {
    return undefined;
  }
  try {
    const payload = JSON.parse(atob(token.substr(7).split('.')[1])),
     lifetime = (payload.exp - payload.iat) * 1000;

    return {
      lifetime,
      expiresAt: payload.exp,
      expiresIn: Math.floor((lifetime / 3) * 2)
    };
  } catch (e) {
    return undefined;
  }
};

export interface State {
  loading: boolean;
  loggedIn: boolean;
  user?: User;
  token?: string;
  sessionId?: string;
  lifetime?: number;
  expiresAt?: number;
  expiresIn?: number;
  notifications?: Notification[];
  forgotPasswordMailSentStatus: boolean;
  forgotPasswordMailSentResponse: string;
}

export const initialState: State = {
  loading: false,
  loggedIn: false,
  user: undefined,
  token: undefined,
  sessionId: undefined,
  lifetime: undefined,
  expiresAt: undefined,
  expiresIn: undefined,
  notifications: [],
  forgotPasswordMailSentStatus: false,
  forgotPasswordMailSentResponse: undefined,
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOGIN:
      return { ...state, loading: true, loggedIn: false, user: undefined };
    case actions.ActionTypes.LOGIN_SUCCESS:
      return {
        ...state, loggedIn: true, loading: false, token: action.payload.token,
        sessionId: action.payload.vds, ...getExpiration(action.payload.token)
      };
    case actions.ActionTypes.LOGIN_FAILED:
      return { ...state, loading: false, loggedIn: false, user: undefined };
    case actions.ActionTypes.LOG_LOGOUT_SUCCESS:
      return {
        ...state, user: undefined, loading: false, loggedIn: false, token: action.payload.token,
        lifetime: undefined, expiresAt: undefined, expiresIn: action.payload.expiresIn
      };
    // return { ...state, loading: false, loggedIn: false, token: undefined, user: undefined };
    case actions.ActionTypes.GET_USER_SUCCESS:
      return { ...state, loggedIn: true, loading: false, user: action.payload };

    case actions.ActionTypes.UPDATE_USER_PREFERENCES:
      return {
        ...state, user: state.user ? {
          ...state.user,
          settings: state.user.settings ? {
            ...state.user.settings,
            preferences: action.payload
          } : undefined
        } as User : undefined
      };

    case actions.ActionTypes.UPDATE_USER_NOTIFICATIONS:
      return {
        ...state, user: state.user ? {
          ...state.user,
          settings: state.user.settings ? {
            ...state.user.settings,
            notifications: action.payload
          } : undefined
        } as User : undefined
      };

    case actions.ActionTypes.UPDATE_USER_REPORTS:
      return {
        ...state, user: state.user ? {
          ...state.user,
          settings: state.user.settings ? {
            ...state.user.settings,
            reports: action.payload
          } : undefined
        } as User : undefined
      };

    case actions.ActionTypes.UPDATE_USER_PROFILE_IMAGE_SUCCESS:
      return {
        ...state, user: state.user ? {
          ...state.user,
          profileImageId: action.payload
        } as User : undefined
      };
    case actions.ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE_SUCCESS:
      return {
        ...state, user: state.user ? {
          ...state.user,
          profileImageId: undefined
        } as User : undefined
      };
    case actions.ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE_FAILED:
      return {
        ...state, user: state.user ? {
          ...state.user
        } as User : undefined
      };

    case actions.ActionTypes.REFRESH_TOKEN_SUCCESS:
      return { ...state, token: action.payload.token, ...getExpiration(action.payload.token) };
    case actions.ActionTypes.REFRESH_TOKEN_FAILED:
      return { ...state, token: undefined, lifetime: undefined, expiresAt: undefined, expiresIn: undefined };

    case actions.ActionTypes.ACCEPT_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        user: state.user ? {
          ...state.user,
          settings: state.user.settings ? {
            ...state.user.settings,
            optIns: {
              ...state.user.settings.optIns,
              terms: state.user.settings.optIns.terms ? state.user.settings.optIns.terms : new Date()
            }
          } : undefined
        } as User : undefined
      };

    case actions.ActionTypes.CLEAR_STATE:
      return initialState;

    case actions.ActionTypes.LOAD_USER_NOTIFICATIONS_SUCCESS:
      return { ...state, notifications: action.payload };

    case actions.ActionTypes.FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotPasswordMailSentStatus: true, forgotPasswordMailSentResponse: action.payload.ResponseMessage };
    case actions.ActionTypes.FORGOT_PASSWORD_RESET_FORM:
      return { ...state, forgotPasswordMailSentStatus: false, forgotPasswordMailSentResponse: '' };

    default:
      return state;
  }
}
